export const ssoAppApiBaseUrl = import.meta.env.VITE_APP_SSO_REDIRECT_URI;
